import React from 'react';

export const MiniQr = (props: { className?: string }) => {
    return (
        <svg
            width='8'
            height='8'
            viewBox='0 0 8 8'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={props.className}>
            <path
                d='M6.75 3.75V6.15C6.75 6.30913 6.68679 6.46174 6.57426 6.57426C6.46174 6.68679 6.30913 6.75 6.15 6.75H3.75M6.25 0.75H6.75M0.75 6.75V6.25M1.35 0.75H3.15C3.48137 0.75 3.75 1.01863 3.75 1.35V3.15C3.75 3.48137 3.48137 3.75 3.15 3.75H1.35C1.01863 3.75 0.75 3.48137 0.75 3.15V1.35C0.75 1.01863 1.01863 0.75 1.35 0.75Z'
                stroke='currentColor'
                stroke-width='1.5'
                stroke-linecap='round'
                stroke-linejoin='round'
            />
        </svg>
    );
};

export default MiniQr;
